<template>
    <b-card>
      <b-card-title class="mb-1">
        Top Pairs Volume
      </b-card-title>
      <b-card-sub-title class="mb-2">
        Last 30 Days
      </b-card-sub-title>
  
      <vue-apex-charts
        v-if="loaded"
        type="donut"
        height="400"
        :options="apexChartData.topPairsChart.chartOptions"
        :series="apexChartData.topPairsChart.series"
      />
    </b-card>
  </template>
  
  <script>
  import {
    BCard, BCardTitle, BCardSubTitle,
  } from 'bootstrap-vue'
  import VueApexCharts from 'vue-apexcharts'
  import apexChartData from './apexChartData'
  import axios from 'axios'
  
  export default {
    components: {
      VueApexCharts,
      BCard,
      BCardTitle,
      BCardSubTitle,
    },
    data() {
      return {
        apexChartData,
        loaded: false,
      }
    },
    mounted() {
        this.loaded = false;
        axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/0a57fce4-e2d8-4415-8a7a-3f349357da22/data/latest')
        .then(response => {
            apexChartData.topPairsChart.series = []
            apexChartData.topPairsChart.chartOptions.labels = []
            for (let index = 0; index < 10; index++) {
                const element = response.data[index];
                if(element.PAIR.includes("WOO")) apexChartData.topPairsChart.series.push(element.VOLUME / 1000)
                else apexChartData.topPairsChart.series.push(element.VOLUME)                
                apexChartData.topPairsChart.chartOptions.labels.push(element.PAIR)
            }
            this.loaded = true;
        })
        .catch(e => console.error(e))
    },
  }
  </script>
  